<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('report.report_setting')"
    icon="res-report-setting"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :res-id="data.id" :is="params.windowData.currentTab" :id="listId" :data="detailData" :onManager="onManager" :getParams="getParams" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import DataList from './Data'
import SubscriptionList from './Subscription/index'
export default {
  name: 'ReportSettingSidePage',
  components: {
    Actions,
    DataList,
    SubscriptionList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('report.report'), key: 'data-list' },
        { label: this.$t('report.subscription'), key: 'subscription-list' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      return {}
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'data-list':
          return 'ReportDataList'
        case 'subscription-list':
          return 'ReportSubscriptionListSidePage'
        case 'event-drawer':
          return 'EventListForMonthReportSidePage'
        default:
          return ''
      }
    },
  },
}
</script>
